import MdaeLoader from "./component";
export default MdaeLoader;
